import { FC, CSSProperties } from 'react';
import confirmModalClass from '../../assets/scss/ConfirmModal/ConfirmModal.module.scss';

export const ConfirmTitle: FC<{
  title: string;
  style?: CSSProperties;
}> = ({ title, style }) => {
  return (
    <>
      <div className={confirmModalClass.titleBox}>
        <h3
          className={confirmModalClass.title}
          style={{ textAlign: 'center', ...style }}
        >
          {title}
        </h3>
      </div>
    </>
  );
};
